module.exports = __webpack_public_path__ + "static/basic_btn-152f907e2f1f383b243a.png";